import ProtectInfoContainer from "./ProtectInfoContainer";
import ProtectInfoStore from "./ProtectInfoStore";

export default ProtectInfoStore(ProtectInfoContainer);